import React, { useState, useEffect, useRef } from 'react';
import '../styles/Profile.css';
const avatarImage = '/1111.png';

function Profile() {
  const [showPopup, setShowPopup] = useState(false);
  const [fadeClass, setFadeClass] = useState('');
  const popupContentRef = useRef(null);
  const popupRef = useRef(null);

  useEffect(() => {
    const handleWheel = (e) => {
      if (!showPopup) return;

      if (popupRef.current && popupRef.current.contains(e.target)) {
        const content = popupContentRef.current;
        if (!content) return;

        const { scrollTop, scrollHeight, clientHeight } = content;
        const isScrollingUp = e.deltaY < 0;
        const isScrollingDown = e.deltaY > 0;
        const isAtTop = scrollTop <= 0;
        const isAtBottom = scrollTop + clientHeight >= scrollHeight;

        if ((isAtTop && isScrollingUp) || (isAtBottom && isScrollingDown)) {
          e.preventDefault();
          e.stopPropagation();
        }
      } else {
        e.preventDefault();
        e.stopPropagation();
      }
    };

    const handleTouchMove = (e) => {
      if (showPopup && (!popupRef.current || !popupRef.current.contains(e.target))) {
        e.preventDefault();
      }
    };

    if (showPopup) {
      document.body.style.overflow = 'hidden';
      window.addEventListener('wheel', handleWheel, { passive: false, capture: true });
      window.addEventListener('touchmove', handleTouchMove, { passive: false, capture: true });
    }

    return () => {
      document.body.style.overflow = '';
      window.removeEventListener('wheel', handleWheel, { capture: true });
      window.removeEventListener('touchmove', handleTouchMove, { capture: true });
    };
  }, [showPopup]);

  const openPopup = () => {
    setFadeClass('');
    setShowPopup(true);
  };

  const closePopup = () => {
    setFadeClass('fade-out');
    setTimeout(() => setShowPopup(false), 400);
  };

  return (
    <section id="profile" className="profile">
      <div
        className="profile-container"
        onMouseEnter={(e) => e.currentTarget.classList.add('hover-effect')}
        onMouseLeave={(e) => e.currentTarget.classList.remove('hover-effect')}
        onClick={openPopup}
      >
        <div className="profile-content">
          <div className="profile-avatar">
            <img src={avatarImage} alt="あなたの名前" className="avatar-image" loading="lazy" />
          </div>
          <div className="profile-text">
            <h2 className="profile-name">Alex</h2>
            <p className="profile-description">
              AI・機械学習エンジニアの<span>Alex</span>です。LLMとデータエンジニアリングを核に、RAG/LLMOps、CV/NLPの実装・評価を専門としています。
              SaaS・金融・EC領域での業務自動化と意思決定支援に強みがあり、短期PoCから本番運用まで、成果に直結するソリューションを設計・導入します。
            </p>
          </div>
        </div>
      </div>

      {showPopup && (
        <div
          className={`popup-overlay ${fadeClass}`}
          onClick={closePopup}
        >
          <div
            ref={popupRef}
            className="popup-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="close-button" onClick={closePopup}>&times;</button>
            <h3 className="popup-title">経歴・実績</h3>
            <div 
              ref={popupContentRef} 
              className="popup-scrollable-content"
            >
              <div className="popup-description">
                <p style={{ textIndent: '1em', marginBottom: '1.5em' }}>
                  東京工業大学大学院 情報理工学系修了。CV/NLP を中心に研究し、成果を AI 分野のトップカンファレンスで発表。
                  理論と実装の両面から課題を分解し、再現性の高い評価設計に強みがあります。
                </p>
                <p style={{ textIndent: '1em', marginBottom: '1.5em' }}>
                  産業領域では IT・金融・SaaS・EC を横断して、AI を活用した業務システムを設計・開発。
                  例：財務データからのレポート自動生成と可視化、RAG を用いたチャット検索、音声合成検出の PoC など。
                  アーキテクチャ設計から MLOps/LLMOps まで一貫して支援します。
                </p>
                <p style={{ textIndent: '1em', marginBottom: '1.5em' }}>
                  短期 PoC で仮説を検証し、KPI/評価指標を設計した上で本番運用へ移行。
                  ユーザー価値と ROI を最優先に、品質・セキュリティ・運用性まで配慮したソリューションを提供します。
                  最新技術のキャッチアップと継続的改善にコミットしています。
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default Profile;